import commonService from '@/services/common/common.service';
import keycloakService from '@/services/common/keycloak.service';

/** 로그인 사용자 정보 조회 */
const getLoginUser = (context) => {
  {

    return new Promise((resolve, reject) => {
      commonService.getCurrentLoginUserInfo()
        .then(result => {
          if (result.data.status === 'ok') {
            if (result.data.result) {
              return result.data.result
            } else {
              //logout(payload.access_token);
            }
          } else {
            //logout(payload.access_token);
          }
        })
        .then(async json => {

          context.commit("setAccessDenied", false);
          if (json.siteCd === "BESPIN") {
            //동시 로그인 제한 설정 관련 체크
            context.commit("setLoginDeniedConCurrent", false);
            if (json.useConcurrent !== '1') {
              context.commit("setLoginDeniedConCurrent", true);
            }
            //MFA 2단계 인증 설정여부
            context.commit("setOtpDenied", false);
            if (json.useOtp === '0') {
              context.commit("setOtpDenied", true);
            }
            // ip 있는지 없는지 체크
            context.commit("setAllowedIpNull", false);
            if (json.allowedIpaddr == null) {
              context.commit("setAllowedIpNull", true);
            }
            // ip addr입력되었을때 ip 유효성 체크
            context.commit("setAllowedIpDenied", false);
            if (json.passIpaddr !== 'Y') {
              context.commit("setAllowedIpDenied", true);
            }
          }
          context.commit('SET_LOGIN_USER_INFO', json);
          context.commit('SET_LOGIN', true);

          resolve();
        })
        .catch((err) => {
          reject(err);
        })
    });
  }
}

export default {
  getLoginUser
};



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js